const sizeConfigs = {
  sidebar: {
    width: "250px"
  }
};

export default sizeConfigs;